import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function Intro({ onDone }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t0 = setTimeout(() => setShow(true), 60);
    const t1 = setTimeout(() => onDone?.(), 4200);
    return () => { clearTimeout(t0); clearTimeout(t1); };
  }, [onDone]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-[#0a1224]"
      data-testid="intro-screen"
      onClick={() => onDone?.()}
      style={{
        backgroundImage:
          "radial-gradient(circle at 50% 30%, rgba(29,78,140,0.25), transparent 60%), linear-gradient(rgba(10,18,36,0.86), rgba(10,18,36,0.96)), url(https://images.unsplash.com/photo-1586161148512-64a1b3dac527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="flex flex-col items-center transition-all duration-1000 ease-out"
        style={{ opacity: show ? 1 : 0, transform: show ? "translateY(0)" : "translateY(16px)" }}
      >
        <div className="bg-white rounded-2xl px-10 py-8 shadow-2xl shadow-black/40 ring-1 ring-white/10">
          <img src="/brand/oomining.jpeg" alt="OOMINING — Mine Management Software"
            className="h-28 sm:h-36 w-auto object-contain" data-testid="intro-logo" />
        </div>
        <p className="mt-8 text-white/70 text-sm tracking-[0.35em] uppercase font-mono-num">
          Mine Management Software
        </p>
      </div>

      <div
        className="absolute bottom-14 flex flex-col items-center gap-4 transition-opacity duration-1000"
        style={{ opacity: show ? 1 : 0 }}
      >
        <Button
          onClick={(e) => { e.stopPropagation(); onDone?.(); }}
          data-testid="intro-continue-btn"
          className="rounded-full px-8 h-11 gap-2 bg-white text-[#0a1224] hover:bg-white/90 font-medium"
        >
          Entrar <ArrowRight className="h-4 w-4" />
        </Button>
        <span className="text-white/35 text-[11px] uppercase tracking-widest">EMAURAN · by OOMINING</span>
      </div>

      <div className="absolute bottom-0 left-0 h-1 bg-primary/70" style={{ width: show ? "100%" : "0%", transition: "width 4.2s linear" }} />
    </div>
  );
}
